import React from "react";
import { Box } from "@mui/material";
import Redirect from "./components/Redirect";

export default function RedirectPage() {
  return (
    <Box sx={{ height: "100%" }}>
      <Redirect />
    </Box>
  );
}